import React, { useEffect, useState } from "react";
import { NAV_LINKS, ASSETS } from "../data/entrepminds";
import { Menu, X } from "lucide-react";
import { useCalendly } from "../lib/CalendlyContext";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState("home");
  const calendly = useCalendly();

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 20);
      const sections = NAV_LINKS.map((l) => document.getElementById(l.id));
      const y = window.scrollY + 140;
      for (let i = sections.length - 1; i >= 0; i--) {
        const el = sections[i];
        if (el && el.offsetTop <= y) {
          setActive(NAV_LINKS[i].id);
          break;
        }
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-[#faf7ee]/85 backdrop-blur-xl border-b border-[#e8e2cf]"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <button
          onClick={() => go("home")}
          data-testid="nav-logo-btn"
          className="flex items-center gap-3 group"
        >
          <img
            src={ASSETS.logo}
            alt="Entrepminds"
            className="h-12 w-auto object-contain"
          />
          <span className="sr-only">Entrepminds</span>
        </button>

        <nav className="hidden lg:flex items-center gap-8" aria-label="primary">
          {NAV_LINKS.map((link) => (
            <button
              key={link.id}
              data-testid={`nav-link-${link.id}`}
              onClick={() => go(link.id)}
              className={`nav-link ${active === link.id ? "active" : ""}`}
            >
              {link.label}
            </button>
          ))}
        </nav>

        <div className="hidden lg:block">
          <button
            data-testid="nav-cta-btn"
            onClick={() => calendly?.open()}
            className="btn-gold text-sm"
          >
            Book a Diagnostic
          </button>
        </div>

        <button
          aria-label="Toggle menu"
          data-testid="nav-mobile-toggle"
          className="lg:hidden text-[#8a6a10] p-2"
          onClick={() => setOpen(!open)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="lg:hidden bg-[#faf7ee]/95 backdrop-blur-xl border-t border-[#e8e2cf]"
        >
          <div className="px-6 py-6 flex flex-col gap-5">
            {NAV_LINKS.map((link) => (
              <button
                key={link.id}
                data-testid={`nav-mobile-link-${link.id}`}
                onClick={() => go(link.id)}
                className="text-left nav-link text-base"
              >
                {link.label}
              </button>
            ))}
            <button
              data-testid="nav-mobile-cta"
              onClick={() => {
                setOpen(false);
                calendly?.open();
              }}
              className="btn-gold text-sm w-fit"
            >
              Book a Diagnostic
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
